// 툴바 칩 (시안 .chip). props: on, onClick, children, title
import React from 'react';
import { S } from '../theme';

function Chip(props) {
  return (<button type="button" className={'v2-chip' + (props.on ? ' on' : '')} title={props.title} onClick={props.onClick}
    style={props.on ? S.chipOn : S.chip} aria-pressed={!!props.on}>{props.children}</button>);
}

export default Chip;
